/*Reads auth-token from GET parameter to session storage*/

(function () {
  var reload = false;
  var search = window.location.search;
  var searches = [];
  if (search.length > 1) {
    search = search.substring(1).split('&').filter(a => a).map(a => a.split('='));
    for (let i = 0; i < search.length; i++) {
      if (search[i][0] === 'auth-token') {
        localStorage.setItem('auth-token', search[i][1]);
        reload = true;
        break;
      } else {
        searches.push(search[i][0] + '=' + search[i][1]);
      }
    }
  }
  if (searches.length) {
    search = '?' + searches.join('&');
  } else {
    search = '';
  }
  if (window.location.pathname.length > 1) {
    reload = true;
  }
  if (reload) {
    window.location = window.location.protocol + '//' + window.location.host + '#' + window.location.pathname + search;
  }
})();


// WEBPACK FOOTER //
// ./src/helpers/auth.js